<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { LifeFileDTO } from '@/composables/memorize/memorize'
import { MEDIA_VIDEO } from '@/composables/media/media'

const props = defineProps({
  files: {
    type: Array as PropType<Array<LifeFileDTO>>,
    required: true
  }
})

const mediaFiles = computed(() => props.files)

defineEmits(['onMediaClick'])
</script>
<template>
  <div
    v-if="mediaFiles && mediaFiles.length > 0"
    grid
    :class="
      mediaFiles.length < 2
        ? 'grid-cols-1'
        : mediaFiles.length < 5
          ? 'grid-cols-2 md:grid-cols-3 gap-1.5'
          : 'grid-cols-3 md:grid-cols-3 gap-1.5'
    "
    w-full
    justify-items-center>
    <div
      v-for="(item, index) in mediaFiles"
      relative
      :key="index"
      :class="mediaFiles.length < 2 ? 'w-7/12 justify-self-center overflow-hidden rounded-2' : 'w-full overflow-hidden'"
      bg-theme-light
      @click="$emit('onMediaClick', item)">
      <RLazyImage :key="index" :src="item.file?.lowQuality || item.file?.url || ''" :aspectRatio="1"></RLazyImage>
      <div
        v-if="item.file.type === MEDIA_VIDEO"
        i-ph:play-circle-light
        z-1
        text-5xl
        class="centered-element"
        text-inverted
        opacity-90 />
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
